<template>
    <div>
        <input
            :class="{'font-italic': disabled, 'money-bold': bold}"
            v-if="!isReadOnly"
            type="text"
            v-model="displayValue"
            :placeholder="placeholder"
            @blur="isInputActive = false"
            @focus="isInputActive = true" />
        <input
            :class="{'font-italic': disabled, 'money-bold': bold}"
            v-else
            type="text"
            readonly
            v-model="displayValue" />
    </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      default: '',
      type: String,
      required: false
    },
    amount: {
      default: 0,
      type: String | Number,
      required: false
    },
    localeOverride: {
      type: String,
      default: null
    },
    currencyCode: {
      type: String,
      default: 'EUR'
    },
    supplementalPrecision: {
      type: Number,
      default: 0
    },
    subunitsValue: {
      type: Boolean,
      default: true
    },
    subunitsToUnit: {
      type: Number,
      default: 1
    },
    hideSubunits: {
      type: Boolean,
      default: false
    },
    readonly: {
      default: false,
      type: Boolean,
      required: false
    },
    disabled: {
      type: String | Boolean,
      required: false
    },
    bold: {
      type: String | Boolean,
      required: false
    }
  },
  data () {
    return {
      initialValue: this.amount,
      isInputActive: false,
      isReadOnly: this.readonly
    }
  },
  computed: {
    displayValue: {
      get: function () {
        if (this.isInputActive) {
          return parseInt(this.initialValue)
        } else {
          return this.formatMoney(this.initialValue)
        }
      },
      set: function (modifiedValue) {
        this.initialValue = parseInt(modifiedValue)
      }
    },
    locale () {
      return this.localeOverride || this.$i18n.locale
    }
  },
  methods: {
    //
    // Format money based on integer or floating input
    // ===============================================
    // Possible inputs are:
    // amount:                Numerical input (required)
    // locale:                Language and country information, such as 'en' or 'en-US'
    // currencyCode:          3-character code from ISO 4217
    // subunitsValue:         Value is denominated in subunits, such as cents
    // subunitsToUnits:       Overrides the minor unit value from ISO 4217. The "subunitsValue"
    //                        option is redundant if you enter a value for this
    // hideSubunits:          Set this to true if you don't want to display the subunits
    // supplementalPrecision: Allows you to display partial subunits . This is ignored if
    //                        you specify "hideSubunits=true"
    //
    formatMoney (amount) {
      let ret = 0
      if (Number.isFinite(parseInt(amount))) {
        try {
          let numFormat = new Intl.NumberFormat(this.locale, {style: 'currency', currency: this.currencyCode})
          let options = numFormat.resolvedOptions()
          if (this.subunitsToUnit > 1) {
            amount = amount / this.subunitsToUnit
          } else if (this.subunitsValue === true) {
            amount = amount / 10 ** options.minimumFractionDigits
          }
          if (this.hideSubunits === true) {
            numFormat = new Intl.NumberFormat(this.locale, {
              style: 'currency',
              currency: this.currencyCode,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })
          } else if (this.supplementalPrecision > 0) {
            numFormat = new Intl.NumberFormat(this.locale, {
              style: 'currency',
              currency: this.currencyCode,
              minimumFractionDigits: options.minimumFractionDigits + this.supplementalPrecision,
              maximumFractionDigits: options.maximumFractionDigits + this.supplementalPrecision
            })
          }
          ret = numFormat.format(amount)
        } catch (err) {
          ret = err.message
        }
      } else {
        ret = 0
      }
      return ret
    }
  },
  watch: {
    initialValue (val) {
      this.$emit('update:amount', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/MoneyInput.vue